import React, { useEffect } from "react";
import "../style/page/Contact.css";
import { useContactForm } from "../hooks/websiteHooks";
import { useTranslation } from "../contexts/TranslationContext";
import { useContactContent } from "../hooks/useContactContent";

function Contact() {
  // Initialize contact form functionality
  useContactForm();
  const { t } = useTranslation();
  const { title, description, cardsHtml, metaTitle } = useContactContent();

  // Update page title when content changes
  useEffect(() => {
    if (metaTitle) {
      document.title = metaTitle;
    }
  }, [metaTitle]);

  return (
    <main className="main-content contact-page">
      <h4 className="page-title">{title}</h4>

      <p className="description">{description}</p>

      <div className="contact-wrapper" dangerouslySetInnerHTML={{ __html: cardsHtml }} />
    </main>
  );
}

export default Contact;
